import { render, staticRenderFns } from "./mc-waste.tests.vue?vue&type=template&id=4149502a&scoped=true"
import script from "./mc-waste.tests.vue?vue&type=script&lang=ts"
export * from "./mc-waste.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4149502a",
  null
  
)

export default component.exports